const E={CHANNEL_UNSPECIFIED:0,WHATSAPP:1,RCS:2,SMS:3,MESSENGER:4,VIBER:5,VIBERBM:6,MMS:7,TELEGRAM:8,INSTAGRAM:9,KAKAOTALK:10,NATIVE_CHANNEL:11,APPLEBC:12,WECHAT:13,LINE:14,UNRECOGNIZED:-1};export{E as ConversationChannel};
//# sourceMappingURL=conversation_channel.js.map
